import { AISummaryType } from 'hooks/useGetAISummary'
import useHasFeature, { AppFeatures, AppSubFeatures } from 'hooks/useHasFeature'
import React from 'react'
import { IInteraction } from 'views/Metrics/HistoricMetrics/types'
import AISummary from 'widgets/AISummary'
import { CallComprehension } from 'widgets/CallComprehension'
import { CallRecording } from 'widgets/CallRecording'
import CallTranscription from 'widgets/CallTranscription'
import { ContactDetails } from 'widgets/ContactDetails'
import { VideoSharingHistory } from 'widgets/VideoSharing/VideoSharingHistory'
import './voice-widgets.scss'

interface Props {
    interaction: IInteraction
}

const VoiceWidgets: React.FC<Props> = ({ interaction }) => {
    const hasFeature = useHasFeature()

    return (
        <div data-testid="voice-widgets" className="contact-history-voice-widgets">
            {hasFeature(AppFeatures.AI_FEATURES, [
                AppSubFeatures.AI_ACTION_FLOWS_POST_CONTACT_SUMMARIES_VOICE,
            ]) ? (
                <AISummary contact={interaction} type={AISummaryType.POST_CONTACT_VOICE} />
            ) : hasFeature(AppFeatures.AI_FEATURES, [AppSubFeatures.VOICE_SUMMARIES]) ? (
                <AISummary contact={interaction} type={AISummaryType.VOICE_CHAT} />
            ) : null}
            {hasFeature(AppFeatures.CALL_TRANSCRIPTION) && (
                <CallTranscription contactID={interaction.ID} />
            )}
            {hasFeature(AppFeatures.CALL_COMPREHENSION) && (
                <CallComprehension contactID={interaction.ID} widgetTitle="Sentiment analysis" />
            )}
            {hasFeature(AppFeatures.CALL_RECORDING) && (
                <CallRecording
                    key={interaction.ID}
                    contactID={interaction.ID}
                    recordingDate={interaction.initiationTimestamp}
                    widgetTitle="Audio"
                    recordings={interaction.recordings}
                />
            )}
            {hasFeature(AppFeatures.CALL_DETAILS) && (
                <ContactDetails contact={interaction} widgetTitle="Additional info" />
            )}
            {hasFeature(AppFeatures.VIDEO_MEETING, [AppSubFeatures.VIDEO_MEETING_VIEW_RECORDS]) && (
                <VideoSharingHistory contact={interaction} />
            )}
        </div>
    )
}

export default VoiceWidgets
